import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["icon", "iconAriaLabel"];
import { jsx } from 'react/jsx-runtime';
import { IconIconOnLight, Size5 } from '@box/blueprint-web-assets/tokens/tokens';
import clsx from 'clsx';
import { forwardRef, createElement } from 'react';
import styles from './base-inline-notice.module.js';
var BaseInlineNoticeIcon = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var icon = props.icon,
      iconAriaLabel = props.iconAriaLabel,
      rest = _objectWithoutProperties(props, _excluded);

  if (!icon) {
    return null;
  }

  var iconElement = /*#__PURE__*/createElement(icon, {
    color: IconIconOnLight,
    width: Size5,
    height: Size5,
    'aria-label': iconAriaLabel
  });
  return jsx("span", _objectSpread(_objectSpread({}, rest), {}, {
    ref: forwardedRef,
    className: clsx(styles.icon),
    children: iconElement
  }));
});
export { BaseInlineNoticeIcon };